import React, { useState } from 'react';
import styles from './styles.module.scss';
import { useEffect } from 'react';
import classNames from 'classnames';

export interface ToggleProps {
    toggled?: boolean;
    onChange: Function;
    className?: string;
    ariaLabel: string;
}

function Toggle(props: ToggleProps) {
    const [toggleState, setToggleState] = useState(props.toggled || false);

    useEffect(() => {
        props.onChange(toggleState);
    }, [toggleState]);

    function handleToggle() {
        setToggleState(!toggleState);
    }

    return (
        <button
            type="button"
            role="switch"
            aria-checked={toggleState}
            aria-label={props.ariaLabel}
            className={classNames([styles.container, props.className], {
                [styles.toggled]: toggleState,
            })}
            onClick={handleToggle}
        >
            <div
                className={classNames([styles.toggleButton], {
                    [styles.toggled]: toggleState,
                })}
            ></div>
        </button>
    );
}

export default Toggle;
